/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import { Icon, TextareaControl } from '@wordpress/components';
import { registerBlockType, createBlock, rawHandler } from '@wordpress/blocks';
import { Fragment } from '@wordpress/element';
import { BlockControls, useBlockProps } from '@wordpress/block-editor';
import { Button, Popover,ToolbarGroup, ToolbarDropdownMenu, MenuItem, Spinner } from '@wordpress/components';
import { useState, useRef, renderToString } from '@wordpress/element';
import { select } from '@wordpress/data';
/**
 * Icons
 */
import icons from './icons.js';
/**
 * Options
 */
import { writingStyles, languages } from './options';
import {MoMoAIHelperBreakdownMarkdown, MoMOAIHelperConvertMarkdownToHTML, MoMoAIHelperExtractTableData} from './woo.helper.markdown.js';
const slowType = (text, setText) => {
    let currentIndex = 0;
    const typingDelay = 500; // Delay between each character (in milliseconds)
    setText(text + ' ');
    /* const typeNextCharacter = () => {
      if (currentIndex < ( text.length - 1 ) ) {
        console.log(text[currentIndex]);
        setText(prevText => prevText + text[currentIndex]);
        currentIndex++;
        setTimeout(typeNextCharacter, typingDelay);
      }
    };

    typeNextCharacter(); */
};

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

export default function Edit(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [isWorking, setIsWorking] = useState(false);
    const [resultReady, setResultReady] = useState(false);
    const [generatedBlocks, setGeneratedBlocks] = useState([]);
    const { className, clientId } = props;
    const [text, setText] = useState('');
    const aiHelperTextAreaRef = useRef(null);
    const blockRef = useRef(null);

    const HelperToolbarDropdown = ({ label, options }) => {
        const toggleDropdown = () => {
            setIsOpen(!isOpen);
        };
        const menuItems = options.map((option, index) => (
            <MenuItem key={index} onClick={option.onClick}>
                {option.title}
            </MenuItem>
        ));
    
        return (
            <Fragment>
                <Button onClick={toggleDropdown}>{label}</Button>
                {isOpen && (
                    <Popover
                    position="bottom right"
                    className="momo-toolbar-custom-dropdown"
                    onClose={() => setIsOpen(false)}
                    >
                    <div className="popover-menu">
                        <ul>{menuItems}</ul>
                    </div>
                    </Popover>
                )}
            </Fragment>
        );
    };
    const menus = {
        summarize: __('Write product description on', 'momoacg' ),
        tutorial: __('Write a Step by step tutorial on', 'momoacg' ),
        informative: __('An informative article on', 'momoacg' ),
        insights: __('Inspiring Insights into', 'momoacg' ),
        analysis: __('In-Depth analysis on', 'momoacg' ),
    };

    const handleMenuItemClicked = (index) => {
        slowType(menus[index], setText);
        setIsOpen(false);
        aiHelperTextAreaRef.current.focus();
    };

    const dropdownOptions = [
        {
          title: menus.summarize,
          onClick: () => handleMenuItemClicked('summarize'),
        },
        {
          title: menus.tutorial,
          onClick: () => handleMenuItemClicked('tutorial'),
        },
        {
        title: menus.informative,
            onClick: () => handleMenuItemClicked('informative'),
        },
        {
        title: menus.insights,
            onClick: () => handleMenuItemClicked('insights'),
        },
        {
        title: menus.analysis,
            onClick: () => handleMenuItemClicked('analysis'),
        },
    ];
    const handleChange = (event) => {
        const newText = event.target.value;
        setText(newText);
    };
    const btnHandleCall = (event) => {
        const block =  document.querySelector(`[data-block="${clientId}"]`);
        const textPrompt = block.querySelector('textarea[name="momo-aihelper-prompt-textarea"]');
        handleAPICall(textPrompt.value, 'initial');
    };
    const handleKeyDown = (event) => {
        if (event.keyCode === 13) {
          event.preventDefault();
          const { value } = event.target;
          handleAPICall(value, 'initial');
        }
    };
    const abortController = new AbortController();
    const slowWriteResult = async(content, element) => {
        return new Promise((resolve) => {
            const frameDelay = 0.1; // Delay between frames in milliseconds
            let currentIndex = 0;
            let lastTimestamp = 0;

            function updateContent(timestamp) {
                if (timestamp - lastTimestamp >= frameDelay) {
                    const endIndex = Math.min(currentIndex + 3, content.length);
                    const currentContent = content.slice(0, endIndex);
                    element.innerHTML = currentContent;

                if (currentIndex < content.length) {
                    currentIndex += 3;
                }

                lastTimestamp = timestamp;
                }

                if (currentIndex < content.length) {
                    requestAnimationFrame(updateContent);
                } else {
                    resolve(); // Animation complete, resolve the promise
                }
            }

            requestAnimationFrame(updateContent);
        });
    }
    const handleAPICall = (prompt, type, oldData = '') => {
        setIsWorking(true);
        setResultReady(false);
        fetch( momo_ai_helper_script.rest_aihelper, {
            method: 'POST',
            body: JSON.stringify({ prompt: prompt, type: type, old_data: oldData }),
            headers: {
              'Content-Type': 'application/json'
            },
            signal: abortController.signal
        })
        .then(response => response.json())
        .then(data => {
            // Handle the API response data
            setResultReady(true);
            setTimeout(() => {
                const block =  document.querySelector(`[data-block="${clientId}"]`);
                const divElement = block.querySelector('.momo-aihelper-temp-result');
                if (divElement) {
                    const markdownHTML = MoMOAIHelperConvertMarkdownToHTML(data.message);
                    slowWriteResult(markdownHTML, divElement)
                    .then(() => {
                        setIsWorking(false);
                    });
                    /* divElement.innerHTML = markdownHTML; */
                    divElement.setAttribute('data-markdown', data.message);
                }
            }, 1000);

        })
        .catch(error => {
            // Handle any error that occurs during the API call
            console.error(error);
            setIsWorking(false);
        });
    }
    const handleAbortAPICall = () => {
        abortController.abort(); // Abort the fetch request
        setIsWorking(false);
    };
    const handleAcceptCommand = () => {
        const blocks = [];
        let blockIndex = 0;
        const block =  document.querySelector(`[data-block="${clientId}"]`);
        const divElement = block.querySelector('.momo-aihelper-temp-result');
        const markdownContent = divElement.getAttribute('data-markdown');

        // Split the content into paragraphs and headings
        const breakUps = MoMoAIHelperBreakdownMarkdown(markdownContent);

        breakUps.forEach((element, index) => {
            if ( 'p' === element.tagName.toLowerCase()) {
                const contentWithoutDivs = element.innerHTML.replace(/<div>|<\/div>/g, '');
                const paraBlock = createBlock('core/paragraph', {
                        content: contentWithoutDivs,
                    }
                );
                blocks.push(
                    paraBlock
                );
            } else {
                const rawBlock = rawHandler({
                    HTML: element.outerHTML,
                    mode: 'BLOCKS',
                    rawContentType: 'text/html',
                });
                blocks.push(
                    rawBlock[0]
                );
            }
            blockIndex++;
        });
        wp.data.dispatch('core/block-editor').replaceBlocks(clientId, blocks);
    };

    const [selectedOption, setSelectedOption] = useState('Informative');

    const handleChangeWritingStyle = (newOption) => {
        const block =  document.querySelector(`[data-block="${clientId}"]`);
        const divElement = block.querySelector('.momo-aihelper-temp-result');
        const oldData = divElement.getAttribute('data-markdown');
        handleAPICall(newOption, 'style', oldData);
    };
    const handleChangeLanguage = (newOption) => {
        const block =  document.querySelector(`[data-block="${clientId}"]`);
        const divElement = block.querySelector('.momo-aihelper-temp-result');
        const oldData = divElement.getAttribute('data-markdown');
        handleAPICall(newOption, 'language', oldData);
    };
    const handleRewiteArticle = (newOption) => {
        const block =  document.querySelector(`[data-block="${clientId}"]`);
        const divElement = block.querySelector('.momo-aihelper-temp-result');
        const oldData = divElement.getAttribute('data-markdown');
        handleAPICall(newOption, 'rewrite', oldData);
    };
    const handleTryAgain = () => {
        setResultReady(false);
        const block =  document.querySelector(`[data-block="${clientId}"]`);
        const textPrompt = block.querySelector('textarea[name="momo-aihelper-prompt-textarea"]');
        textPrompt.value = '';
        textPrompt.focus();
    };
    return (
        <div { ...useBlockProps() }>
            <Fragment>
                {!resultReady || isWorking ? (
                    <BlockControls>
                        <ToolbarGroup
                            className='momo-toolbar-group'
                        >
                            <HelperToolbarDropdown
                                icon ={null}
                                label={__('Predefined text...', 'momoacg')}
                                options={dropdownOptions} />
                        </ToolbarGroup>
                    </BlockControls>
                ) : (
                    <BlockControls>
                        <ToolbarGroup
                            className='momo-toolbar-group result-ready'
                        >
                            <ToolbarDropdownMenu
                                icon={ icons.tone }
                                label={__('Change Writing Style', 'momoacg')}
                                controls={
                                    writingStyles.map((style) => ({
                                        title: style.title,
                                        onClick: () => handleChangeWritingStyle(style.value),
                                        isActive: selectedOption === style.value,
                                    }))
                                }
                            />
                            <ToolbarDropdownMenu
                                icon={icons.globe}
                                label={__('Change Language', 'momoacg')}
                                controls={
                                    languages.map((language) => ({
                                        title: language.title,
                                        onClick: () => handleChangeLanguage(language.value),
                                        isActive: selectedOption === language.value,
                                    }))
                                }
                            />
                            <ToolbarDropdownMenu
                                icon={ icons.repeat }
                                label={__('Rewrite', 'momoacg')}
                                controls={[
                                    {
                                        title: __('Make it longer', 'momoacg'),
                                        onClick: () => handleRewiteArticle('longer'),
                                        isActive: selectedOption === 'longer',
                                    },
                                    {
                                        title: __('Make it shorter', 'momoacg'),
                                        onClick: () => handleRewiteArticle('shorter'),
                                        isActive: selectedOption === 'shorter',
                                    },
                                    {
                                        title: __('Summarize it', 'momoacg'),
                                        onClick: () => handleRewiteArticle('summarize'),
                                        isActive: selectedOption === 'summarize',
                                    },
                                ]}
                            />
                        </ToolbarGroup>
                        <ToolbarGroup
                            className='momo-toolbar-group result-ready'
                        >
                            <Button
                                label={__('Try Again', 'momoacg')}
                                onClick={()=> handleTryAgain()}
                            >
                            {__('Try Again', 'momoacg')}
                            </Button>
                        </ToolbarGroup>
                        <ToolbarGroup
                            className='momo-toolbar-group result-ready'
                        >
                            <Button
                                label={__('Accept', 'momoacg')}
                                onClick={()=> handleAcceptCommand()}
                            >
                            {__('Accept', 'momoacg')}
                            </Button>
                        </ToolbarGroup>
                    </BlockControls>
                )}
            <div className={className} ref={blockRef}>
                {resultReady && (
                <div 
                    className="momo-aihelper-temp-result"
                ></div>
                )}
                <div
                className='momo-aihelper-block-container'
                >
                    {isWorking && (
                    <div className="momo-aihelper-block-wrapper">
                        <Spinner
                            color="red"
                        />
                    </div>
                    )}
                    <Icon icon={icons.circle} className='momo-aihelper-block-icon' size={20} />

                    <textarea
                        ref={aiHelperTextAreaRef}
                        name="momo-aihelper-prompt-textarea"
                        className="momo-aihelper-block-textarea"
                        placeholder={ __('Write product description on ..', 'momoacg' ) }
                        onChange={ handleChange }
                        value={text}
                        onKeyDown={handleKeyDown}
                    />
                    {!isWorking && (
                    <Button className='momo-aihelper-block-button' onClick={btnHandleCall}>
                    
                        <i class="bx bxs-send"></i>{__('Send', 'momoacg')}
                    </Button>
                    )}
                    {isWorking && (
                        <Button className='momo-aihelper-block-button momo-outer' onClick={handleAbortAPICall}>
                            <i class='bx bx-stop-circle'></i>{__('Stop', 'momoacg')}
                        </Button>
                    )}
                    {resultReady && (
                        <Button className='momo-aihelper-block-button' onClick={handleAcceptCommand}>
                        <i class='bx bx-list-check'></i>{__('Accept', 'momoacg')}
                        </Button>
                    )}
                </div>
            </div>
            </Fragment>
        </div>
    );
}